// extracted by mini-css-extract-plugin
export default {"layout":"_1EALD","relative":"_1CxKW","fixed":"_1dnIU","loader":"_2703L","fade-in":"_3cYav","lds-default":"_3x2Ry","top":"NWTeW"};